import axios from "axios";
import { memo, useEffect, useRef, useState } from "react";
import { Redirect, useHistory } from "react-router";
import { getSession, processInt, processNum, processStr, processStrWithSpace, processStrWithSpaceAndSpecalChars, valdiatePage } from "../../global";
import { getCountries, getServices, save, getNTN } from '../../services/intlbookingservice';
import { getSubAccountLocations } from '../../services/userservice';
import Loader from '../../images/whiteloader.svg';

const InternationalBooking = () => {
    const subAccounts = getSession('subaccounts')
    const d = {
        cnType: 12,
        countryId: '',
        consignee: '',
        consigneeAddress: '',
        consigneePhone: '',
        consigneePostCode: '',
        pcs: '',
        serviceType: '',
        weight: '',
        refNo: '',
        pcs: '',
        W: '',
        H: '',
        L: '',
        insured: false,
        insurancePer: 2.5,
        insAmount: '',
        decAmount: '',
        billWeight: '',
        volWeight: '',
        content: '',
        instructions: '',
        locationId: '',
        subAccountId: '',
        accountNo: '',
        nic: '',
        ntn: '',
        CNICFile: '',
        InvoiceFile: '',
        SupportingDocsFile: ''
    };
    const [CNICFile, setCNICFile] = useState([]);
    const [InvoiceFile, setInvoiceFile] = useState([]);
    const [SupportingDocsFile, setSupportingDocsFile] = useState([]);
    const [data, setData] = useState(d);
    const [countries, setCountries] = useState([]);
    const [locations, setLocations] = useState([]);
    const [services, setServices] = useState([]);
    const [loading, setLoading] = useState(false);

    const history = useHistory();

    useEffect(() => {
        const CancelToken = axios.CancelToken;

        const source = CancelToken.source();
        if (valdiatePage('/internationalbooking')) {
            const loadData = async (source) => {
                const rsc = await getCountries(source);
                setCountries(rsc);
            };

            const u = getSession('userInfo');
            if (u)
                loadData(source);
        } else {
            history.push('/login');
        }

        return () => {
            source.cancel('Operation cancelled by the user.');
        }
    }, []);

    const validate = (u) => {
        //Consignee Name is Required
        //Consignee Address is Required
        //Consignee Mobile No is Required
        //Destination Country is Required
        //Pieces is Required
        //Ref No is Required
        //Service Type is Required
        //Consignee Name Length Must be Less than or Equals to 50
        //Consignee Address Length Must be Less than or Equals to 255
        //Consignee Email Length Must be Less than or Equals to 50
        //Content Length Must be Less than or Equals to 600
        //Ref No Length Must be Less than or Equals to 50
        //Pieces Must be Greater than to 0
        //Weight Must be Greater than to 0
        //Max Alowed Weight Exceeds (9999)
        //Max Alowed Weight Exceeds (99)
        //COD amount must be greater than 0

        // Atleast one file should be uploaded

        if (!data.subAccountId) {
            alert('Sub Account is required');
            return false;
        }

        if (!data.locationId) {
            alert('Location is required');
            return false;
        }
        if (!data.countryId) {
            alert('Country is required');
            return false;
        }

        if (!data.consignee || data.consignee.trim() === '') {
            alert('Consignee Name is required');
            return false;
        }

        if (!data.consigneePhone) {
            alert('Consignee Phone is required');
            return false;
        } else {
            if (data.consigneePhone.length < 11) {
                alert('Consignee Phone is Invalid');
                return false;
            }
        }

        if (!data.consigneePostCode) {
            alert('Consignee Postal Code is required');
            return false;
        }

        if (!data.consigneeAddress || data.consigneeAddress.trim() === '') {
            alert('Consignee Address is required');
            return false;
        }

        if (!data.weight || data.weight <= 0) {
            alert('Weight is required');
            return false;
        } else {
            if (data.weight > 99) {
                alert('Weight is greater than 99');
                return false;
            }
        }

        if (parseFloat(data.weight) > 2 && (data.serviceType.includes('_Doc') || data.serviceType.includes('Documents'))) {
            alert('For Documents, Weight should not exceed 2 Kg');
            return false;
        }

        if (!data.pcs || data.pcs <= 0) {
            alert('Pieces is required');
            return false;
        }

        if (!data.refNo) {
            alert('Ref No is required');
            return false;
        }

        if (!data.instructions) {
            alert('Special Instructions is required');
            return false;
        }

        if (CNICFile == "") {
            alert('Upload image of NIC/NTN/Passport');
            return false;
        }
        if (InvoiceFile == "") {
            alert('Upload image of Invoice');
            return false;
        }

        return true;
    }
    const cnicref = useRef();
    const invoiceref = useRef();
    const supportingdocref = useRef();
    const reset = () => {
        setData(prev => {
            return { ...d, subAccountId: prev.subAccountId, locationId: prev.locationId };
        });
        setCNICFile([]);
        setInvoiceFile([]);
        setSupportingDocsFile([]);
        cnicref.current.value = null;
        invoiceref.current.value = null;
        supportingdocref.current.value = null;
    }

    const onSave = async () => {
        const u = getSession('userInfo');
        if (validate(u)) {
            const z = {
                "CN": 0,
                "CNType": data.cnType,
                "ServiceType": data.serviceType,
                "Country": data.countryId,
                "Consignee": data.consignee,
                "ConsigneeAddress": data.consigneeAddress,
                "ConsigneePhone": data.consigneePhone,
                "ConsigneePostCode": data.consigneePostCode,
                "Pcs": data.pcs,
                "Weight": data.weight,
                "W": data.W,
                "H": data.H,
                "L": data.L,
                "billWeight": data.billWeight,
                "volWeight": data.volWeight,
                "Insured": data.insured,
                "InsuredPer": data.insurancePer,
                "InsAmount": data.insAmount,
                "DecAmount": data.decAmount,
                "Content": data.content,
                "Instructions": data.instructions,
                "RefNo": data.refNo,
                "User": {
                    "id": u.id,
                    "isDuplicateOrderAllowed": u.isDuplicateOrderAllowed
                },
                "LocationId": data.locationId,
                "SubAccountId": data.subAccountId,
                "AccountNo": data.accountNo,
                "CNIC": data.nic,
                "NTN": String(data.ntn),
                "CNICImage": CNICFile == '' ? "" : CNICFile,
                "Invoice": InvoiceFile == '' ? "" : InvoiceFile,
                "SupportingDocs": SupportingDocsFile == '' ? "" : SupportingDocsFile
            };
            setLoading(true);
            const rs = await save(z);
            setLoading(false);
            alert(rs.msg);
            if (rs.ok) {
                // let CN = rs.msg.split(' ');
                //z.CN = CN[1];
                sessionStorage.setItem('internationalData', JSON.stringify(rs.data))
                console.log(rs.data);
                window.open('/cplight/internationalprint.html', '_blank');
                reset();
            }
        }
    }

    const fileToBase64 = (file, cb) => {
        const reader = new FileReader()
        reader.readAsDataURL(file)
        reader.onload = function () {
            cb(null, reader.result)
        }
        reader.onerror = function (error) {
            cb(error, null)
        }
    }

    const onUploadCNICFileChange = ({ target }) => {
        if (target.files < 1 || !target.validity.valid) {
            return
        }
        fileToBase64(target.files[0], (err, result) => {
            if (result) {
                setCNICFile(result);
            }
        })
    }

    const onUploadInvoiceFileChange = ({ target }) => {
        if (target.files < 1 || !target.validity.valid) {
            return
        }
        fileToBase64(target.files[0], (err, result) => {
            if (result) {
                setInvoiceFile(result);
            }
        })
    }

    const onUploadSupportingDocsFileChange = ({ target }) => {
        if (target.files < 1 || !target.validity.valid) {
            return
        }
        fileToBase64(target.files[0], (err, result) => {
            if (result) {
                setSupportingDocsFile(result);
            }
        })
    }

    const updateData = (key, val) => setData(prevState => { return { ...prevState, [key]: val }; });

    useEffect(() => {
        let x = 0;
        if (data.W && data.H && data.L) {
            x = (+data.W * +data.H * +data.L) / 5000;
        }
        let d = { ...data };
        d['volWeight'] = x.toFixed(1);
        d['billWeight'] = +data.weight > x ? (+data.weight).toFixed(1) : x.toFixed(1);
        setData(d);
    }, [data.weight, data.W, data.H, data.L]);

    useEffect(() => {
        if (!data.insured) {
            updateData('decAmount', '');
        }
    }, [data.insured]);


    return getSession('userInfo') && <section className="section">
        <div className="section-header">
            <h1>International Booking</h1>
        </div>
        <div className="card" style={{ padding: 10 }}>
            <div className="row">
                <div className="col-lg">
                    <label>Sub Account</label>
                    <select className="form-select" value={data.subAccountId} onChange={(e) => updateData('subAccountId', e.target.value)}
                        onChange={async (e) => {
                            const val = e.target.value;
                            const accno = e.target[e.target.selectedIndex].getAttribute('data-accno');
                            setData({ ...data, subAccountId: val, locationId: '', accountNo: accno });
                            if (val) {
                                const u = getSession('userInfo');
                                const locs = await getSubAccountLocations(u.id, val)
                                if (locs)
                                    setLocations(locs);
                            } else {
                                setLocations([]);
                            }
                        }}>
                        <option value="">Select Account</option>
                        {
                            subAccounts.filter(x => x.isCod == false).map((x, index) =>
                                <option key={index} value={x.id} data-accno={x.accountNo}>{x.name}</option>)
                        }
                    </select>
                </div>
                <div className="col-lg">
                    <label>Locations</label>
                    <select className="form-select" value={data.locationId} onChange={(e) => updateData('locationId', e.target.value)}
                        onChange={async (e) => {
                            const val = e.target.value;
                            setData({ ...data, locationId: val });
                            if (val) {
                                const servs = await getServices();
                                if (servs)
                                    setServices(servs);
                                const u = getSession('userInfo');
                                const ntn = await getNTN(u.id, data.accountNo, val);
                                if (ntn) {
                                    updateData('ntn', ntn)
                                }
                            } else {
                                setServices([]);
                            }
                        }}>
                        <option value="">Select Location</option>
                        {
                            locations.map((x, index) => <option key={index} value={x.value}>{x.text}</option>)
                        }
                    </select>
                </div>
                <div className="col-lg">
                    <label>Service Type</label>
                    <select className="form-select" value={data.serviceType} onChange={(e) => updateData('serviceType', e.target.value)}>
                        <option value="">Select ServiceType</option>
                        {
                            services.map((x, index) => <option key={index} value={x}>{x}</option>)
                        }
                    </select>
                </div>
                <div className="col-lg">
                    <label>Consignment Type</label>
                    <select className="form-select" value={data.cnType} disabled={true} onChange={(e) => updateData('cnType', e.target.value)}>
                        <option value="12">Normal</option>
                        <option value="13">Hand Carry</option>
                    </select>
                </div>
                <div className="col-lg">
                    <label>Destination Country</label>
                    <select className="form-select" value={data.countryId} onChange={(e) => updateData('countryId', e.target.value)}>
                        <option value="">Select Country</option>
                        {
                            countries.map((x, index) => <option key={index} value={x.value}>{x.text}</option>)
                        }
                    </select>
                </div>
                <div className="col-lg">
                    <label>Forwarding Station</label>
                    <input type="text" maxLength={15} className="form-control" readOnly='readOnly' value='KARACHI' />
                </div>
            </div>
            <div className="row mt-3">
                <div className="col-lg">
                    <label>Consignee Name</label>
                    <input type="text" className="form-control" maxLength={50} value={data.consignee} onInput={processStrWithSpace} onChange={(e) => updateData('consignee', e.target.value)} />
                </div>
                <div className="col-lg">
                    <label>Consignee Phone</label>
                    <input type="text" className="form-control" maxLength={15} value={data.consigneePhone} onInput={processInt} onChange={(e) => updateData('consigneePhone', e.target.value)} />
                </div>
                <div className="col-lg">
                    <label>Postal Code</label>
                    <input type="text" className="form-control" maxLength={11} onInput={processStrWithSpaceAndSpecalChars} value={data.consigneePostCode} onChange={(e) => updateData('consigneePostCode', e.target.value)} />
                </div>
                <div className="col-lg">
                    <label>Consignee Address</label>
                    <textarea className="form-control" maxLength={255} value={data.consigneeAddress} onInput={processStrWithSpace} onChange={(e) => updateData('consigneeAddress', e.target.value)}></textarea>
                </div>
            </div>
            <div className="row mt-3">
                <div className="col-lg">
                    <label>Dense Weight</label>
                    <input type="text" className="form-control" maxLength={4} value={data.weight} onInput={processNum}
                        onChange={(e) => updateData('weight', e.target.value)} />
                </div>
                <div className="col-lg">
                    <label>W (CM)</label>
                    <input type="text" className="form-control" maxLength={4} value={data.W} onInput={processNum} onChange={(e) => updateData('W', e.target.value)} />
                </div>
                <div className="col-lg">
                    <label>H (CM)</label>
                    <input type="text" className="form-control" maxLength={4} value={data.H} onInput={processNum} onChange={(e) => updateData('H', e.target.value)} />
                </div>
                <div className="col-lg">
                    <label>L (CM)</label>
                    <input type="text" className="form-control" maxLength={4} value={data.L} onInput={processNum} onChange={(e) => updateData('L', e.target.value)} />
                </div>
                <div className="col-lg">
                    <label>Vol Weight</label>
                    <input type="text" className="form-control" readOnly={true} value={data.volWeight} onInput={processNum} onChange={(e) => updateData('volWeight', e.target.value)} />
                </div>
                <div className="col-lg">
                    <label>Bill Weight</label>
                    <input type="text" className="form-control" readOnly={true} value={data.billWeight} onInput={processNum} onChange={(e) => updateData('billWeight', e.target.value)} />
                </div>
                <div className="col-lg">
                    <label>Pieces</label>
                    <input type="text" className="form-control" maxLength={2} value={data.pcs} onInput={processNum} onChange={(e) => updateData('pcs', e.target.value)} />
                </div>

                <div className="col-lg">
                    <label>Insured</label>
                    <label className="switch">
                        <input type="checkbox" value={data.insured} checked={data.insured} name="select" onChange={(x) => updateData('insured', x.target.checked)} />
                        <span className="slider round"></span>
                    </label>
                </div>
                <div className="col-lg">
                    <label>Insurance %</label>
                    <input type="text" className="form-control" readOnly={true} value={data.insurancePer} onInput={processNum} onChange={(e) => updateData('insurancePer', e.target.value)} />
                </div>
                <div className="col-lg">
                    <label>Declared Amount</label>
                    <input type="text" className="form-control" readOnly={!data.insured} maxLength={8} value={data.decAmount} onInput={processNum} onChange={(e) => updateData('decAmount', e.target.value)} />
                </div>
                <div className="col-lg">
                    <label>Insurance Amount</label>
                    <input type="text" className="form-control" readOnly={true} value={data.decAmount == null ? data.insAmount : ((data.decAmount * data.insurancePer) / 100).toFixed(1)} onInput={processNum} onChange={(e) => updateData('insAmount', e.target.value)} />
                </div>
            </div>
            <div className="row mt-3">
                <div className="col-lg">
                    <label>Package Content</label>
                    <textarea className="form-control" maxLength={600} value={data.content} onInput={processStrWithSpace} onChange={(e) => updateData('content', e.target.value)}></textarea>
                </div>
                <div className="col-lg">
                    <label>Special Instructions</label>
                    <textarea className="form-control" maxLength={600} value={data.instructions} onInput={processStrWithSpace} onChange={(e) => updateData('instructions', e.target.value)}></textarea>
                </div>
                <div className="col-lg-1">
                    <label>Ref No</label>
                    <input type="text" className="form-control" maxLength={20} value={data.refNo} onInput={processStr} onChange={(e) => updateData('refNo', e.target.value)} />
                </div>
                <div className="col-lg">
                    <label>NTN</label>
                    <input className="form-control" disabled maxLength={600} value={data.ntn} onInput={processNum} onChange={(e) => updateData('ntn', e.target.value)}></input>
                </div>
            </div>
            <div className="row mt-3">
                <div className="col-lg">
                    <label>NIC/ Passport#</label>
                    <input className="form-control" maxLength={13} value={data.nic} onInput={processNum} onChange={(e) => updateData('nic', e.target.value)}></input>
                </div>

                <div className="col-lg">
                    <label>CNIC/NTN/Passport Upload</label>
                    <input type="file" className="form-control" name="CNICFile" ref={cnicref} id="CNICFile" accept="image/jpeg,image/png,application/pdf" onChange={onUploadCNICFileChange}></input>
                    {CNICFile ? <textarea id="CNICImage" hidden rows="30" cols="150" value={CNICFile} readOnly></textarea> : null}
                </div>
                <div className="col-lg">
                    <label>Invoice Upload</label>
                    <input type="file" className="form-control" name="InvoiceFile" ref={invoiceref} id="InvoiceFile" accept="image/jpeg,image/png,application/pdf" onChange={onUploadInvoiceFileChange}></input>
                    {InvoiceFile ? <textarea id="InvoiceImage" hidden rows="30" cols="150" value={InvoiceFile} readOnly></textarea> : null}
                </div>
                <div className="col-lg">
                    <label>Supporting Docs Upload</label>
                    <input type="file" className="form-control" name="SupportingDocsFile" ref={supportingdocref} id="SupportingDocsFile" accept="image/jpeg,image/png,application/pdf" onChange={onUploadSupportingDocsFileChange}></input>
                    {SupportingDocsFile ? <textarea id="SupportingDocs" hidden rows="30" cols="150" value={SupportingDocsFile} readOnly></textarea> : null}
                </div>
                <div className="col-lg" style={{ display: 'flex', flexDirection: 'column', justifyContent: 'flex-end', alignItems: 'flex-end' }}>
                    <button type="button" className="btn btn-primary" disabled={loading} onClick={onSave}>
                        {loading ? <img src={Loader} height="30" /> : 'Save'}
                    </button>
                </div>
            </div>
            <div className="row mt-6 text-danger">
                <br />
                <div className="col-lg">
                    <p><b>Note:</b></p>
                    <ul style={{ paddingLeft: 15 }}>
                        <li><b>Billed Weight is equal to Dense Weight Or Vol Weight which ever is higher</b></li>
                    </ul>
                </div>
            </div>
        </div>
    </section>
}

export default InternationalBooking;